import { useId, useState } from 'react'
import { Mtds } from 'prove-common'

type EditableBooleanFieldProps = {
  value: boolean
  label: string
  canEdit: boolean
  isSaving?: boolean
  trueLabel?: string
  falseLabel?: string
  onSave: (value: boolean) => void | Promise<void>
}

export const EditableBooleanField = ({
  value,
  label,
  canEdit,
  isSaving = false,
  trueLabel = 'Ja',
  falseLabel = 'Nei',
  onSave
}: EditableBooleanFieldProps) => {
  const popoverId = useId()
  const [draft, setDraft] = useState(value)

  const valueLabel = value ? trueLabel : falseLabel

  if (!canEdit) return <>{valueLabel}</>

  const open = () => setDraft(value)
  const cancel = () => setDraft(value)
  const save = async () => {
    if (draft !== value) await onSave(draft)
  }

  return (
    <>
      <Mtds.Button
        type='button'
        data-variant='tertiary'
        popoverTarget={popoverId}
        disabled={isSaving}
        onClick={open}
        className='-mx-1 h-auto min-h-0 min-w-0 justify-start p-1 font-normal'
      >
        {valueLabel}
      </Mtds.Button>
      <Mtds.Popover id={popoverId} className='w-72 p-3'>
        <div className='grid gap-3'>
          <Mtds.Heading as='p' data-size='2xs'>
            {label}
          </Mtds.Heading>
          <Mtds.Field
            as='select'
            aria-label={label}
            value={String(draft)}
            disabled={isSaving}
            options={[
              { label: trueLabel, value: 'true' },
              { label: falseLabel, value: 'false' }
            ]}
            onChange={({ target }) => setDraft(target.value === 'true')}
          />
          <Mtds.Flex data-gap='2'>
            <Mtds.Button
              type='button'
              popoverTarget={popoverId}
              popoverTargetAction='hide'
              disabled={isSaving}
              onClick={cancel}
            >
              Avbryt
            </Mtds.Button>
            <Mtds.Button
              type='button'
              data-variant='primary'
              popoverTarget={popoverId}
              popoverTargetAction='hide'
              disabled={isSaving}
              onClick={() => void save()}
            >
              Lagre
            </Mtds.Button>
          </Mtds.Flex>
        </div>
      </Mtds.Popover>
    </>
  )
}
